<template>
  <div class="editor">
    <!-- 菜单区 -->
    <div ref="toolbar" class="toolbar"></div>
    <!--编辑内容区-->
    <div ref="editor" class="text">
      <!--可使用 min-height 实现编辑区域自动增加高度-->
    </div>
  </div>
</template>

<script>
  import { uploadFileToOSS } from "@/utils/oss.js";
import { mapState } from 'vuex';
import Editor from 'wangeditor';
  // import { uploadfileUrl, imgUrl } from "@/apis/apis";   // uploadfileUrl 上传图片的地址  imgUrl  加载图片时的地址（后端返回的一般是图片的路径，需要加上图片的地址）
  let baseURL = process.env.NODE_ENV === 'development' ? 'http://designerapi.cn/api/' : 'https://deapi.yichuanghub.com/api/'
  let imgUrl = process.env.NODE_ENV === 'development' ? 'https://img.hongli.xingjuju.com/' : 'https://img.hongli.xingjuju.com'
  export default {
    name: 'WangEditor',
    props: {
      value: {
        type: String,
        default: '',
      },
      isClear: {
        type: Boolean,
        default: false,
      },
      dir: {
        type: String,
        default: 'pc',
      }
    },
    data() {
      return {
        editor: null,
        info_: null,
        uploadfileUrl: baseURL + '/util/upload-images', // 上传图片时的地址
        imgUrl, // 加载图片时的地址 （拼接后台返回的图片路径）
      }
    },
    computed: {
      ...mapState({
        oss: 'aliyun_oss',
      }),
    },
    mounted() {
      this.setEditor()
      // console.log(this.editor.txt.html())  // this.editor.txt.html() 为编辑区内容
      this.editor.txt.html(this.value)
    },
    methods: {
        // 设置编辑器
      setEditor() {
        this.editor = new Editor(this.$refs.toolbar, this.$refs.editor)

        //>关闭粘贴样式过滤
        this.editor.config.pasteFilterStyle = true

        //>自定义处理粘贴的文本内容
        this.editor.config.pasteTextHandle = function (content) {
          //>content 即粘贴板里的内容
          //>创建一个临时的 div 来解析 HTML
          const div = document.createElement('div')
          div.innerHTML = content
          
          //>获取纯文本内容
          let text = div.innerText || div.textContent

          // console.log('text---test',text);
          
          //?去除多余的空行或空白字符以及html标签
          text = text.replace(/(\n\s*\n)/g, '\n').replace(/<[^>]+>/g,'').trim()
          // console.log('text---replaced',text);
          return text
        }


        // 配置onchange函数之后，用户操作（鼠标点击、键盘打字等）导致的内容变化之后，会自动触发onchange函数执行。

        this.editor.config.onchange = (html) => {
          console.log('change-html',html);
          // html 即变化之后的内容
          this.info_ = html.replace(/<\/?article[^>]*>/g,''); //>单独处理WangEditor自动生成的article标签
          this.$emit('change', this.info_) // 将内容同步到父组件中
        }

        // 配置菜单(默认的菜单)
        this.editor.config.menus = [
          'head', // 标题
          'bold', // 粗体
          'fontSize', // 字号
          'fontName', // 字体
          'italic', // 斜体
          'underline', // 下划线
          'strikeThrough', // 删除线
          'foreColor', // 文字颜色
          'backColor', // 背景颜色
          'link', // 插入链接
          'list', // 列表
          'justify', // 对齐方式
          'quote', // 引用
          'emoticon', // 表情
          'image', // 插入图片
          'table', // 表格
          'video', // 插入视频
          'code', // 插入代码（可以注释）
          'undo', // 撤销
          'redo', // 重复
          'fullscreen', // 全屏
        ]

        // 上传图片 & 配置
        // 是否使用 base64 保存图片
        this.editor.config.uploadImgShowBase64 = false //  true -> 使用 base64 保存图片 false -> 不使用
        // 配置服务器端地址
        this.editor.config.uploadImgServer = this.uploadfileUrl
        // 限制图片大小
        this.editor.config.uploadImgMaxSize = 10 * 1024 * 1024 // 将图片大小限制为 10M
        // 限制一次最多能传几张图片
        this.editor.config.uploadImgMaxLength = 20 // 限制一次最多上传 10 张图片
        // 自定义上传参数 上传图片时可自定义传递一些参数，例如传递验证的token等。
        this.editor.config.uploadImgParams = { token: '123' }
        // 上传图片时刻自定义设置 header
        this.editor.config.uploadImgHeaders = {
          // 例如：'Accept': 'text/x-json'
        }
        // 自定义 fileName（上传文件的参数名）
        this.editor.config.uploadFileName = 'file'
        // 自定义 timeout 时间 （设置超时时间）
        this.editor.config.uploadImgTimeout = 3 * 60 * 1000 // 将 timeout 时间改为 3 分钟

        //开启多图上传
        this.editor.config.multipleSelection = true

        // 视频上传配置
        this.editor.config.uploadVideoServer = this.uploadfileUrl // 视频上传地址
        this.editor.config.uploadVideoMaxSize = 500 * 1024 * 1024 // 限制视频大小为 500M
        this.editor.config.uploadVideoName = 'file' // 上传文件的参数名
        this.editor.config.uploadVideoTimeout = 10 * 60 * 1000 // 上传超时时间 10 分钟
        this.editor.config.uploadVideoParams = { token: '123' } // 自定义上传参数
        this.editor.config.uploadVideoHeaders = {} // 自定义 header

        // 自定义视频上传
        this.editor.config.customUploadVideo = async (resultFiles, insertVideoFn) => {
          for (let i in resultFiles) {
            let file = resultFiles[i]
            try {
              let url = await uploadFileToOSS(file, `${this.oss.dir}/${this.dir}/videos`)
              insertVideoFn(url)
              // 每插入一个视频后自动换行
              this.editor.txt.append('<p><br/></p>')
            } catch (err) {
              console.error('视频上传失败: ', err)
              this.$layer.msg('视频上传失败')
            }
          }
        }

        // 视频上传 hooks
        this.editor.config.uploadVideoHooks = {
          before: function (xhr, editor, files) {
            // 视频上传之前触发
          },
          success: function (xhr, editor, result) {
            // 视频上传并返回结果，视频插入成功之后触发
          },
          fail: function (xhr, editor, result) {
            // 视频上传并返回结果，但视频插入错误时触发
          },
          error: function (xhr, editor) {
            // 视频上传出错时触发
          },
          timeout: function (xhr, editor) {
            // 视频上传超时时触发
          },
        }

        // 自定义图片上传
        this.editor.config.customUploadImg = async (resultFiles, insertImgFn) => {
          for (let i in resultFiles) {
            let file = resultFiles[i]
            try {
              let url = await uploadFileToOSS(file, `${this.oss.dir}/${this.dir}/images`)
              insertImgFn(url)
              // 每插入一张图片后自动换行
              this.editor.txt.append('<p><br/></p>')
            } catch (err) {
              console.error('图片上传失败: ', err)
              if (err.code === 'IMAGE_SIZE_LIMIT') {
                this.$layer.msg('图片尺寸过大，请检查图片尺寸')
              } else {
                this.$layer.msg('图片上传失败')
              }
            }
          }
        }

        // 可使用监听函数在上传图片的不同阶段做相应处理
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件
        this.editor.config.uploadImgHooks = {
          before: function (xhr, editor, files) {
            // 图片上传之前触发
          },
          success: function (xhr, editor, result) {
            // 图片上传并返回结果，图片插入成功之后触发
          },
          fail: function (xhr, editor, result) {
            // 图片上传并返回结果，但图片插入错误时触发
          },
          error: function (xhr, editor) {
            // 图片上传出错时触发
          },
          timeout: function (xhr, editor) {
            // 图片上传超时时触发
          },
          // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
          // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
          customInsert: function (insertImg, result, editor) {
            // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
            // insertImg 是插入图片的函数，editor 是编辑器对象，result 为上传图片成功的时候 服务器端返回的结果

            // 举例：假如上传图片成功后，服务器端返回的是data:[{url:'图片路径'} ] 这种格式，即可这样插入图片：
            // let url = result.data.url // 图片地址 + 返回的图片的路径
            // insertImg(url)
            // result 必须是一个 JSON 格式字符串！！！否则报错
          },
        }

        // 创建富文本编辑器
        this.editor.create()
      },
    },
    watch: {
      isClear(val) {
        // 触发清除文本域内容
        console.log(val)
        if (val) {
          this.editor.txt.clear()
          this.info_ = null
        }
      },
      value: function (value) {
        if (value !== this.editor.txt.html()) {
          this.editor.txt.html(this.value)
        }
      },
      //value为编辑框输入的内容，这里我监听了一下值，当父组件调用得时候，如果给value赋值了，子组件将会显示父组件赋给的值
    },
  }
</script>

<style lang="css" scoped>
  .editor {
    position: relative;
    z-index: 1 !important;
  }
  .toolbar {
    border: 1px solid #ccc;
  }
  .text {
    border: 1px solid #ccc;
    height: 400px;
  }

  ::v-deep .w-e-text-container {
    z-index: 1 !important;
  }
</style>
